import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { TID } from "@/constants/testIds";

export default function PendingGate() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const rejected = user?.doctor_status === "rejected";
    return (
        <div
            data-testid={TID.doctorPendingScreen}
            className="flex min-h-[calc(100vh-56px)] items-center justify-center px-6"
        >
            <div className="w-full max-w-md border border-veda-border bg-veda-surface p-8 text-center">
                <span className="mx-auto grid h-14 w-14 place-items-center rounded-pill bg-veda-warning/10 text-veda-warning">
                    <ShieldAlert size={22} />
                </span>
                <h1 className="font-display mt-5 text-3xl text-veda-onSurface">
                    {rejected ? "Application not approved" : "Under review"}
                </h1>
                <p className="mt-3 text-sm text-veda-muted">
                    {rejected
                        ? "Our team could not verify your credentials at this time. Please reach us at hello@vedaheal.com to appeal."
                        : "Our team is verifying your credentials. You'll get an email the moment your account is approved."}
                </p>
                <button
                    onClick={async () => {
                        await logout();
                        nav("/");
                    }}
                    className="mt-6 inline-flex items-center gap-2 border border-veda-border bg-veda-surface px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em]"
                >
                    <LogOut size={14} /> Sign out
                </button>
            </div>
        </div>
    );
}
